export function problemStatusToText(status: string) {
    switch (status) {
      case 'new':
          return "Нова";
      case 'solved':
          return "Решена";
      case 'learned':
        return "Научена";
      default:
        throw new Error(`Unknown status: ${status}`);
    }
}

export function problemStatusToColor(status: string) {
  switch (status) {
    case 'new':
      return "blue";
    case 'solved':
      return "burlywood";
    case 'learned':
      return "green";
    default:
      throw new Error(`Unknown status: ${status}`);
  }
}


export function problemStatusToIcon(status: string) {
  switch (status) {
    case 'new':
      return "mdi:new-box";
    case 'solved':
      return "carbon:in-progress";
    case 'learned':
      return "material-symbols:done";
    default:
      throw new Error(`Unknown status: ${status}`);
  }
}

const CLASS_NAMES = ['а', 'б', 'в', 'г', 'д', 'е', 'ж', 'з', 'и'];
const CLASS_NAMES_CAPITALIZED = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З', 'И'];

export function schoolClassToHumanReadable(schoolClass: string, isCapitalized: boolean = true) {
  const names = isCapitalized ? CLASS_NAMES_CAPITALIZED : CLASS_NAMES;
  return names[['a', 'b', 'v', 'g', 'd', 'e', 'j', 'z', 'i'].indexOf(schoolClass)];
}

export function getSchoolClassIds(count: number) {
  return ['a', 'b', 'v', 'g', 'd', 'e', 'j', 'z', 'i'].slice(0, count);
}

const COUNTS = ['нула', 'едно', 'две', 'три', 'четири', 'пет', 'шест', 'седем', 'осем', 'девет', 'десет'];
export function getCount(count: number) {
  return COUNTS[count] || count;
}

export function getSchoolYear(date: Date | string) {
  const d = new Date(date);
  const month = d.getUTCMonth();
  const year = d.getUTCFullYear();
  return month < 6 ? year - 1 : year;
}
